import { Order } from '../types/fleet'

export const initialOrders: Order[] = [
  {
    id: '№ 10482',
    customer: 'Огулджан Аширова',
    phone: '+993 65 40-33-71',
    pickup: 'проспект Махтумкули, 22, подъезд 3',
    dropoff: 'Аэропорт Ашхабад, международный терминал',
    createdAt: '14:02',
    status: 'new',
    price: 85,
    comment: 'Нужно детское автокресло',
  },
  {
    id: '№ 10481',
    customer: 'Ыклым Байрамов',
    phone: '+993 62 11-89-25',
    pickup: 'проспект Огузхан, 39',
    dropoff: 'ТРЦ «Беркарар», улица Гёроглы',
    createdAt: '13:54',
    status: 'new',
    price: 32,
  },
  {
    id: '№ 10480',
    customer: 'Джемал Курбанова',
    phone: '+993 63 66-34-19',
    pickup: 'проспект Арчабиль, 30',
    createdAt: '13:47',
    status: 'new',
    price: 26,
    comment: 'Клиент с багажом',
  },
  {
    id: '№ 10479',
    customer: 'Атамурат Реджепов',
    phone: '+993 61 77-10-38',
    pickup: 'улица Атамурата Ниязова, 61',
    dropoff: 'Железнодорожный вокзал Ашхабад',
    createdAt: '13:31',
    status: 'assigned',
    price: 44,
    driverId: 'd5',
  },
  {
    id: '№ 10478',
    customer: 'Нурана Мяликгулыева',
    phone: '+993 64 23-08-04',
    pickup: 'шоссе Берзеньги, 14',
    dropoff: 'улица Битарап Туркменистан, 6',
    createdAt: '13:12',
    status: 'done',
    price: 21,
    driverId: 'd2',
  },
]
